'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var _reactDatepicker = require('react-datepicker');

var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);

var _ActionCreators = require('../actions/ActionCreators');

var _SectionHeaderComponent = require('./common/SectionHeaderComponent');

var _SectionHeaderComponent2 = _interopRequireDefault(_SectionHeaderComponent);

var _translate = require('../language/translate');

var _ErrorDivComponent = require('./common/ErrorDivComponent');

var _ErrorDivComponent2 = _interopRequireDefault(_ErrorDivComponent);

var _step2Functions = require('../helpers/step2Functions');

var _PurchaseMessageComponent = require('./common/PurchaseMessageComponent');

var _PurchaseMessageComponent2 = _interopRequireDefault(_PurchaseMessageComponent);

var _LoadingComponent = require('../../components/common/LoadingComponent');

var _LoadingComponent2 = _interopRequireDefault(_LoadingComponent);

var _ModalComponent = require('./common/ModalComponent');

var _ModalComponent2 = _interopRequireDefault(_ModalComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UpdateBillingDate = function (_Component) {
  _inherits(UpdateBillingDate, _Component);

  function UpdateBillingDate(props) {
    _classCallCheck(this, UpdateBillingDate);

    var _this = _possibleConstructorReturn(this, (UpdateBillingDate.__proto__ || Object.getPrototypeOf(UpdateBillingDate)).call(this, props));

    _this.handleTermsChange = function (event) {
      _this.setState({ termsAccepted: event.target.checked });
    };

    _this.state = {
      newBillingDate: '',
      termsAccepted: false,
      submitting: false,
      errors: [],
      isReady: false,
      paidMessage: false,
      loading: false,
      showModal: false,
      displaySuccessMessage: false
    };
    return _this;
  }

  _createClass(UpdateBillingDate, [{
    key: 'componentDidMount',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.fetchBillingDetails();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _props$payment = this.props.payment,
          error = _props$payment.error,
          paymentDetails = _props$payment.paymentDetails;
      var completed = this.props.processPayment.completed;
    }
  }, {
    key: 'fetchBillingDetails',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _props$location$query, application_id, source, language, auth, authToken;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _props$location$query = this.props.location.query, application_id = _props$location$query.application_id, source = _props$location$query.source;
                language = this.props.params.language;
                _context2.next = 4;
                return this.props.getAuth(source, language);

              case 4:
                auth = _context2.sent;

                if (!(auth && application_id)) {
                  _context2.next = 12;
                  break;
                }

                authToken = auth.payload.data;

                (0, _translate.setLocale)(language);
                _context2.next = 10;
                return this.props.getBillingDetails(application_id, language, authToken);

              case 10:

                if (this.props.payment.paymentDetails && this.props.payment.paymentDetails.message) {
                  this.setState({ paidMessage: true });
                }

                this.setState({
                  isReady: true,
                  newBillingDate: this.props.payment.paymentDetails.current_billing_date
                });

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchBillingDetails() {
        return _ref2.apply(this, arguments);
      }

      return fetchBillingDetails;
    }()
  }, {
    key: 'showErrors',
    value: function showErrors() {
      if (this.state.errors.length > 0) {
        return this.state.errors.map(function (err) {
          return err.message;
        });
      }
      return null;
    }
  }, {
    key: 'displayMessage',
    value: function displayMessage(message) {
      return _react2.default.createElement(
        'div',
        { className: 'div-center signature-padding' },
        _react2.default.createElement(
          'h3',
          null,
          (0, _translate.t)(message)
        )
      );
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit() {
      var _this2 = this;

      var _props = this.props,
          auth = _props.auth,
          params = _props.params,
          location = _props.location;
      var _props$payment$paymen = this.props.payment.paymentDetails,
          application_id = _props$payment$paymen.application_id,
          source_name = _props$payment$paymen.source_name,
          payment_type = _props$payment$paymen.payment_type;
      var _state = this.state,
          newBillingDate = _state.newBillingDate,
          termsAccepted = _state.termsAccepted;

      return new Promise(function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(resolve, reject) {
          var data;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (_this2.validateError(newBillingDate, termsAccepted)) {
                    _this2.setState({
                      loading: true,
                      formSubmitted: true
                    });

                    data = {
                      application_to_process: [location.query.application_id],
                      billing_date: _this2.state.newBillingDate
                    };

                    _this2.props.updateBillingDate(newBillingDate, application_id, auth, params.language, source_name, data).then(function (_data) {
                      if (!_data.error) {
                        _this2.setState({
                          loading: false,
                          formSubmitted: false,
                          displaySuccessMessage: true
                        });

                        _this2.props.processPayment.completed = true;
                      } else {
                        _this2.setState({
                          loading: false,
                          formSubmitted: false,
                          showModal: true,
                          errorMessage: _data.error
                        });
                      }
                    });
                  }

                case 1:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this2);
        }));

        return function (_x, _x2) {
          return _ref3.apply(this, arguments);
        };
      }());
    }
  }, {
    key: 'validateError',
    value: function validateError(newBillingDate, termsAccepted) {
      var errors = this.state.errors;

      errors = [];

      var validationErrors = (0, _step2Functions.validateNewBillingDate)({
        billing: { billing_date: newBillingDate },
        terms: termsAccepted
      }, this.props.payment.paymentDetails.current_billing_date);

      if (validationErrors.billing.billing_date) {
        errors.push({ message: validationErrors.billing.billing_date });
      }
      if (validationErrors.terms) {
        errors.push({ message: validationErrors.terms });
      }
      this.setState({ errors: errors });
      return errors.length === 0;
    }
  }, {
    key: 'handleCloseModal',
    value: function handleCloseModal() {
      this.setState({ showModal: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props$payment2 = this.props.payment,
          paymentDetails = _props$payment2.paymentDetails,
          error = _props$payment2.error;
      var _props$processPayment = this.props.processPayment,
          completed = _props$processPayment.completed,
          processPaymentError = _props$processPayment.error;
      var _state2 = this.state,
          isReady = _state2.isReady,
          errors = _state2.errors,
          paidMessage = _state2.paidMessage;


      if (!isReady) {
        return _react2.default.createElement(
          'h5',
          { className: 'div-center' },
          (0, _translate.t)('Loading details...')
        );
      }

      if (paidMessage) {
        return this.displayMessage(paymentDetails.message);
      }

      if (!completed && processPaymentError && processPaymentError.warnings.length > 0) {
        return this.displayMessage(processPaymentError.warnings.map(function (warning) {
          return warning;
        }).join(', '));
      }

      if (error && error.length > 0 && !paymentDetails) {
        return alert((0, _translate.t)('' + error.map(function (err) {
          return err;
        })));
      }

      var isPaymentIncomplete = paymentDetails && paymentDetails.payment_status.includes('incomplete');

      var paymentInfoFields = [{ label: 'Payment Date', value: paymentDetails.payment_date }, {
        label: 'Payment Status',
        value: (0, _translate.t)(paymentDetails.payment_status)
      }, { label: 'Cardholder Name', value: paymentDetails.cardholder_name }, { label: 'Credit Card Type', value: paymentDetails.credit_card_type }, { label: 'Last 4 Digits', value: paymentDetails.credit_card_number }, {
        label: isPaymentIncomplete ? 'Premium Charged' : 'Recurring Premium Charged',
        value: paymentDetails.recurring_premium_charged
      }, { label: 'Coverage Period', value: paymentDetails.coverage_period }, { label: 'Current Recurring Bill', value: paymentDetails.current_billing_date }];

      if (this.state.displaySuccessMessage) {
        var message = 'Your billing date has been updated successfully.';
        return this.displayMessage(message);
      }

      return _react2.default.createElement(
        'div',
        { className: 'ingle-form container main-div div-container margin-bottom' },
        errors.length > 0 && _react2.default.createElement(_ErrorDivComponent2.default, { fields: this.showErrors() }),
        _react2.default.createElement(
          _SectionHeaderComponent2.default,
          null,
          (0, _translate.t)('Subscription Payment Information')
        ),
        paymentInfoFields.map(function (field, index) {
          return _react2.default.createElement(
            _reactBootstrap.Row,
            {
              className: (field.className || '') + ' failed-details',
              key: index
            },
            _react2.default.createElement(
              _reactBootstrap.Col,
              { xs: 6 },
              _react2.default.createElement(
                'strong',
                null,
                '' + (0, _translate.t)(field.label)
              )
            ),
            _react2.default.createElement(
              _reactBootstrap.Col,
              { xs: 6, className: (field.className || '') + ' input-label' },
              field.value
            )
          );
        }),
        _react2.default.createElement(
          _SectionHeaderComponent2.default,
          null,
          (0, _translate.t)('New Billing Date')
        ),
        _react2.default.createElement(
          _reactBootstrap.Row,
          null,
          _react2.default.createElement(
            _reactBootstrap.Col,
            { xs: 6 },
            _react2.default.createElement(
              'strong',
              null,
              (0, _translate.t)('New Billing Date')
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Col,
            { xs: 6, className: 'input-label' },
            _react2.default.createElement(_reactDatepicker2.default, {
              selected: this.state.newBillingDate ? (0, _moment2.default)(this.state.newBillingDate) : (0, _moment2.default)(paymentDetails.current_billing_date),
              className: 'ingle-form-date-picker form-control',
              name: (0, _translate.t)('New Billing Date'),
              dateFormat: 'yyyy-MM-DD',
              onChange: function onChange(date) {
                _this3.setState({ newBillingDate: date });
              },
              minDate: (0, _moment2.default)(paymentDetails.start_date),
              maxDate: (0, _moment2.default)(paymentDetails.end_date)
            })
          )
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_PurchaseMessageComponent2.default, {
          fields: {
            terms: {
              value: this.state.termsAccepted,
              onChange: this.handleTermsChange
            }
          },
          price: paymentDetails.recurring_premium_charged,
          showTermsCheckbox: true,
          billingDateUpdate: true
        }),
        _react2.default.createElement(
          'div',
          { className: 'div-center modal-button' },
          _react2.default.createElement(
            _reactBootstrap.Button,
            {
              bsStyle: 'primary',
              className: 'ingle-form-submit-button button',
              disabled: this.state.formSubmitted,
              onClick: this.handleSubmit.bind(this)
            },
            (0, _translate.t)('Update Billing Date')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'signature-padding' },
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'span',
              null,
              (0, _translate.t)('Best Regards'),
              ','
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'strong',
              null,
              paymentDetails.signature.brand
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'strong',
              null,
              (0, _translate.t)('Policy Underwritten By'),
              ':'
            ),
            _react2.default.createElement('br', null),
            paymentDetails.signature.underwriter.map(function (underwriter, i) {
              return _react2.default.createElement(
                'span',
                { key: i },
                underwriter,
                _react2.default.createElement('br', null)
              );
            })
          )
        ),
        _react2.default.createElement(_LoadingComponent2.default, { show: this.state.loading, text: (0, _translate.t)('Processing...') }),
        _react2.default.createElement(_ModalComponent2.default, {
          show: this.state.showModal,
          onHide: this.handleCloseModal.bind(this),
          title: (0, _translate.t)('Error'),
          body: this.state.errorMessage
        })
      );
    }
  }]);

  return UpdateBillingDate;
}(_react.Component);

UpdateBillingDate.propTypes = {
  params: _react2.default.PropTypes.object,
  getBillingDetails: _react2.default.PropTypes.func.isRequired,
  payment: _react2.default.PropTypes.object,
  processPayment: _react2.default.PropTypes.object,
  location: _react2.default.PropTypes.object,
  auth: _react2.default.PropTypes.object.isRequired,
  getAuth: _react2.default.PropTypes.func.isRequired,
  updateBillingDate: _react2.default.PropTypes.func
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    auth: state.api.authorization,
    payment: state.application.paymentDetails,
    processPayment: state.application.processPayment
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getAuth: function getAuth() {
      return dispatch(_ActionCreators.getAuthorization.apply(undefined, arguments));
    },
    getBillingDetails: function getBillingDetails(applicationId, lang, authToken) {
      return dispatch((0, _ActionCreators.getApplicationBillingDetails)(applicationId, lang, authToken));
    },
    updateBillingDate: function updateBillingDate(newBillingDate, applicationId, auth, lang, source, data) {
      return dispatch((0, _ActionCreators.processBillingDateUpdate)(newBillingDate, applicationId, auth, lang, source, data));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UpdateBillingDate);


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/UpdateBillingDate.jsx
// module id = 1656
// module chunks = 0